import React from "react"
import { formatCurrency, formatPercentage } from "@utils/formatNumber"
import { slugMaterialName } from "@utils/helpers"

//-------------------------------------------------------------------
const getColumnDefinition = t => {
  return {
    headerCols: [
      t("col_CatPriceTable_Material"),
      t("col_CatPriceTable_Price"),
      t("col_CatPriceTable_Change"),
    ],
    colSize: 3,
  }
}

//-------------------------------------------------------------------
const getMaterialLink = (materialSlug, countrySlug, language) => {
  let linkMaterialPage =
    language !== "en"
      ? `${process.env.GATSBY_SITE_URL}/${language}/scrap-metal-price/`
      : `${process.env.GATSBY_SITE_URL}/scrap-metal-price/`

  if (countrySlug !== "international") {
    linkMaterialPage += `${countrySlug}/`
  }

  linkMaterialPage += `${materialSlug}/`

  return linkMaterialPage
}

//-------------------------------------------------------------------
const getPriceRows = (
  visiblePriceList,
  t,
  currency,
  locale,
  countrySlug,
  language
) => {
  return visiblePriceList.map(({ materialId, material, avgPrice, diff }) => {
    const materialKey = slugMaterialName(material)
    const materialLink = getMaterialLink(materialKey, countrySlug, language)
    return [
      <a href={materialLink}>{t(`${materialKey}_material_name`)}</a>,
      formatCurrency(avgPrice, locale, currency),
      (diff > 0 ? "+" : "") + formatPercentage(diff, locale, 2),
    ]
  })
}

//-------------------------------------------------------------------
export const generateTableData = (
  currency,
  prices,
  t,
  locale,
  countrySlug,
  language
) => {
  const newTableData = {
    rows: getPriceRows(prices, t, currency, locale, countrySlug, language),
    ...getColumnDefinition(t),
  }

  return newTableData
}
